// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CallTimer__root--vk_k6{font-size:22px;width:0}`, "",{"version":3,"sources":["webpack://./modules/conference/components/CallTimer/CallTimer.scss"],"names":[],"mappings":"AAAA,wBACE,cAAA,CACA,OAAA","sourcesContent":[".root {\n  font-size: 22px;\n  width: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `CallTimer__root--vk_k6`
};
module.exports = ___CSS_LOADER_EXPORT___;
